import { RoutePathProps } from "../../../../AppRoutes/types"

import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';

const purchaseInvoice: RoutePathProps = {
    name: 'purchaseInvoice',
    path: 'purchaseInvoice',
    label: "Purchase Invoices",
    visibleInNav: true,
    requiredPermission:'purchase-invoice:list',
    children: [{
        name: 'createPurchaseInvoice',
        path: 'createPurchaseInvoice',
        label: 'Create Purchase Invoice',
        requiredPermission:'purchase-invoice:create'
    },
    {
        name: 'showPurchaseInvoice',
        path: ':purchaseId',
        label: 'Show Purchase Invoice',
        requiredPermission:'purchase-invoice:read'
    },
    {
        name: 'updatePurchaseInvoice',
        path: 'updatePurchaseInvoice/:id',
        label: 'Update Purchase Invoice',
        requiredPermission:'purchase-invoice:update'
    }
    ]
}

const paymentOut: RoutePathProps = {
    name: 'paymentOut',
    path: 'paymentOut',
    label: "Payment Out",
    visibleInNav: true,
    requiredPermission:'payment-out:list',
    children: [{
        name: 'createPaymentOut',
        path: 'createPaymentOut',
        label: 'Create Payment Out',
        requiredPermission:'payment-out:create'
    },
    {
        name: 'showPaymentOut',
        path: ':paymentOutId',
        label: 'Show Payment Out',
        requiredPermission:'payment-out:read'
    },
    {
        name: 'updatePaymentOut',
        path: 'updatePaymentOut/:id',
        label: 'Update Payment Out',
        requiredPermission:'payment-out:update'
    }]
}

const purchaseReturn: RoutePathProps = {
    name: 'purchaseReturn',
    path: 'purchaseReturn',
    label: "Purchase Return",
    visibleInNav: true,
    requiredPermission:'purchase-return:list',
    children: [{
        name: 'createPurchaseReturn',
        path: 'createPurchaseReturn',
        label: 'Create Purchase Return',
        requiredPermission:'purchase-return:create'
    },
    {
        name: 'showPurchaseReturn',
        path: ':purchaseReturnId',
        label: 'Show Purchase Return',
        requiredPermission:'purchase-return:read'
    },
    {
        name: 'updatePurchaseReturn',
        path: 'updatePurchaseReturn/:id',
        label: 'Update Purchase Return',
        requiredPermission:'purchase-return:update'
    }]
}

const debitNote: RoutePathProps = {
    name: 'debitNote',
    path: 'debitNote',
    label: "Debit Note",
    visibleInNav: true,
    requiredPermission:'debit-note:list',
    children: [{
        name: 'createDebitNote',
        path: 'createDebitNote',
        label: 'Create Debit Note',
        requiredPermission:'debit-note:create'
    },
    {
        name: 'showDebitNote',
        path: ':debitNoteId',
        label: 'Show Debit Note',
        requiredPermission:'debit-note:read'
    },
    {
        name: 'updateDebitNote',
        path: 'updateDebitNote/:id',
        label: 'Update Debit Note',
        requiredPermission:'debit-note:update'
    }]
}

export const purchases: RoutePathProps = ({
    name: 'purchases',
    path: 'purchases',
    label: 'Purchases',
    visibleInNav: true,
    icon: ShoppingBagIcon,
    dummy: true,
    children: [purchaseInvoice, paymentOut, purchaseReturn, debitNote],
    requiredPermission:'purchase:list'
})
